var _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _mask, _g2, _mask2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgErrorPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 710,
    height: 391,
    viewBox: "0 0 710 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.9258,
    height: 26.7576,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 161.088 154.333)",
    fill: "#EDE7F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9267,
    height: 24.7709,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 162.809 155.327)",
    fill: "#B39DDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 26.9258,
    height: 26.7576,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 536.744 181.299)",
    fill: "#EDE7F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.9267,
    height: 24.7709,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 538.465 182.292)",
    fill: "#B39DDB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7237 137.573V134.673H64.009V140.824L64.0177 140.829C64.0367 141.477 64.4743 142.121 65.3305 142.615L103.641 164.733C105.393 165.744 108.232 165.744 109.983 164.733L204.044 110.431C204.879 109.949 205.316 109.324 205.355 108.693L205.355 108.692V108.68C205.358 108.628 205.358 108.576 205.355 108.523L205.362 102.335L200.065 104.472L165.733 84.6523C163.982 83.6413 161.142 83.6413 159.391 84.6523L67.7237 137.573Z",
    fill: "url(#paint0_linear)"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 62.1588 134.683)",
    fill: "#673AB7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 62.1588 134.683)",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 78,
    width: 141,
    height: 81
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 62.1588 134.683)",
    fill: "#673AB7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 78,
    width: 141,
    height: 81
  }, /*#__PURE__*/React.createElement("rect", {
    width: 115.933,
    height: 51.5596,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 62.1588 134.683)",
    fill: "#673AB7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.3732,
    height: 64.3732,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 111.303 81.6006)",
    fill: "#5E35B1"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 0.866041,
    width: 63.3732,
    height: 63.3732,
    rx: 4.5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 79.1848 87.8305)",
    stroke: "#5E35B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.0090332,
    y: 83.894,
    width: 269.353,
    height: 229.597,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.403922 0 0 0 0 0.227451 0 0 0 0 0.717647 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 200.346,
    y1: 102.359,
    x2: 71.0293,
    y2: 158.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A491C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7C5F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.1531,
    y1: -0.145767,
    x2: 57.1962,
    y2: 72.3003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgErrorPurple);
export default __webpack_public_path__ + "static/media/img-error-purple.8b0303a844445096e3b8166de52777af.svg";
export { ForwardRef as ReactComponent };